import React from 'react';
import ReactExport from 'react-export-excel';

import Button from '../../../../components/Button';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface DropoutRawData {
  resultId: number;
  lastPageAnswered: number;
  progressNumber: number;
}

interface DropoutRawDataTableProps {
  dropOutResults: DropoutRawData[];
}

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const DropoutRawDataTable: React.FC<DropoutRawDataTableProps> = ({
  dropOutResults,
}) => {
  const preview = dropOutResults.slice(0, 20);
  return (
    <DashboardChartBox>
      <div style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
        <HeaderTitle>
          <p>Drop-out Raw Data</p>
        </HeaderTitle>
        <div style={{ marginBottom: 16 }}>
          <ExcelFile
            element={
              <Button $marginRight="16px" $width="200px" $height="36px">
                Export all data to Excel
              </Button>
            }
            filename={`DropoutRawData-${new Date().toISOString()}`}
          >
            <ExcelSheet data={dropOutResults} name="DropoutRawData">
              <ExcelColumn label="Respondent ID" value="resultId" />
              <ExcelColumn
                label="Last Page Answered Number"
                value="lastPageAnswered"
              />
              <ExcelColumn label="Progress" value="progressNumber" />
            </ExcelSheet>
          </ExcelFile>
        </div>
        <h4 style={{ marginBottom: '16px' }}>
          Preview List (20 records max):{' '}
        </h4>
        <table className="styled-table">
          <thead>
            <tr>
              <th>Respondent ID</th>
              <th>Last Page Answered Number</th>
              <th>Progress</th>
            </tr>
          </thead>
          <tbody>
            {preview
              ?.sort((a, b) => a.lastPageAnswered - b.lastPageAnswered)
              ?.map((item, index) => (
                <tr key={`raw-${index}`}>
                  <td>{item.resultId}</td>
                  <td>{item.lastPageAnswered}</td>
                  <td>{item.progressNumber}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </DashboardChartBox>
  );
};
export default DropoutRawDataTable;
